module.exports = __webpack_public_path__ + "static/media/job_windows.a9443853.svg";